var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIlustrationServices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 262,
    viewBox: "0 0 254 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1524_3515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254 127C254 196.036 198.036 252 129 252C59.9644 252 4 196.036 4 127C4 57.9644 59.9644 2 129 2C198.036 2 254 57.9644 254 127ZM71.1792 127C71.1792 158.934 97.0665 184.821 129 184.821C160.934 184.821 186.821 158.934 186.821 127C186.821 95.0665 160.934 69.1792 129 69.1792C97.0665 69.1792 71.1792 95.0665 71.1792 127Z",
    fill: "url(#paint0_radial_1524_3515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1797 25.9285C78.6501 1.43985 120.693 -6.14672 159.58 5.69635L152.616 30.7333C131.647 5.35788 79.3523 16.9565 54.4438 36.339C11.5905 69.6853 -6.99337 136.482 27.1945 180.417C61.3824 224.352 107.825 121.263 186.48 208.848L203.937 227.101C159.248 289.561 70.6268 258.314 27.4646 202.846C-15.6976 147.378 -6.78858 67.9238 47.3137 25.8242L47.1797 25.9285Z",
    fill: "url(#paint1_linear_1524_3515)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1524_3515",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.6923 74.1154) rotate(38.8534) scale(222.249)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566108
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661829,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#1B1B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#2B2C2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1524_3515",
    x1: 91.9995,
    y1: 189.5,
    x2: 232,
    y2: 152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5056FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0A0A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1524_3515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 253.879,
    height: 261.334,
    fill: "white",
    transform: "translate(0.120605 0.208496)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustrationServices);
export default __webpack_public_path__ + "static/media/ilustration_services.e3cfab38eebd0f8acc7b403e0d44f4d6.svg";
export { ForwardRef as ReactComponent };